export default __webpack_public_path__ + "bd588ac4623b7bb45e87496940bc684c.png";